import angular from 'angular';

class PaginationController {
    /* @ngInject */
    constructor($log, PaginationSettings) {
        const that = this;
        let pageCount = 0;

        const drawNavigation = page => {
            that.pages = [];

            // if (pageCount > PaginationSettings.NAV_ELEMENTS) {
            //   that.pages.push({
            //     label: '- 10',
            //     number: page - 10,
            //     action: that.changePage
            //   });
            // }

            const halfNavElements = Math.floor(PaginationSettings.NAV_ELEMENTS / 2);

            let startPage = page - halfNavElements;
            let endPage = page + halfNavElements + 1; // count for the current page

            if (startPage < 0) {
                endPage += startPage * -1;
                startPage = 0;
            }

            if (endPage > pageCount - 1) {
                startPage -= endPage - pageCount;
                if (startPage < 0) {
                    startPage = 0;
                }

                endPage = pageCount;
            }

            if (page > halfNavElements && endPage > 7) {
                that.pages.push({
                    label: '1',
                    action: that.goToFirstPage
                });

                if (startPage - 1 > 0) {
                    that.pages.push({
                        label: '...'
                    });
                }
            }

            for (let i = startPage; i < endPage; i++) {
                that.pages.push({
                    label: i + 1,
                    number: i,
                    action: that.changePage
                });
            }

            if (pageCount - page - 1 > halfNavElements) {
                if (endPage + 1 <= pageCount) {
                    if (endPage + 1 !== pageCount) {
                        that.pages.push({
                            label: '...'
                        });
                    }

                    that.pages.push({
                        label: pageCount,
                        action: that.goToLastPage
                    });
                }
            }

            // if (pageCount > PaginationSettings.NAV_ELEMENTS) {
            //   that.pages.push({
            //     label: '+ 10',
            //     number: page + 10,
            //     action: that.changePage
            //   });
            // }
        };

        that.changePage = page => {
            that.currentPage = page;
            drawNavigation(page);
            if (angular.isFunction(that.onPageChange)) {
                that.onPageChange(page);
            }
        };

        that.goToPreviousPage = () => {
            if (that.currentPage > 0) {
                that.changePage(that.currentPage - 1);
            }
        };

        that.goToNextPage = () => {
            if (that.currentPage < (pageCount - 1)) {
                that.changePage(that.currentPage + 1);
            }
        };

        that.goToFirstPage = () => {
            console.log("Changed to first page");
            that.changePage(0);
        };

        that.goToLastPage = () => {
            that.changePage(pageCount - 1);
        };

        const init = () => {
            let pageSize = PaginationSettings.DEFAULT_PAGE_SIZE;
            if (that.pageSize && that.pageSize > 0) {
                pageSize = that.pageSize;
            }

            if (that.elementsCount !== undefined) {
                if (that.elementsCount > 0) {
                    if (that.elementsCount > 0) {
                        try {
                            pageCount = Math.ceil(that.elementsCount / pageSize);
                        } catch (error) {
                            pageCount = 0;
                            that.pages = [];
                            $log.error('PaginationController', 'error creating pagination', error);
                        }
                    }
                }

                that.goToFirstPage();
            }

            
        };

        that.$onInit = init;
    }
}

export default PaginationController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination/pagination.controller.js
 **/